import React from "react";
import {
  Button,
  Card,
  Col,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { BACKEND_URL, FRONTEND_URL } from "../../../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpRightFromSquare,
  faDownload,
  faQrcode,
} from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { message } from "antd";
import axios from "axios";

const QrCodeCard = ({
  user,
  serviceKey,
  title,
  overrideQr,
  overrideBotRef,
}) => {
  const serviceCfg = user?.services?.[serviceKey] || {};
  const qrCodeImage = overrideQr ? overrideQr : serviceCfg?.qrCode || "";
  const botRef = overrideBotRef ? overrideBotRef : serviceCfg?.botRef || "";
  const placeHolderImage = "https://placehold.co/150x150?text=No+Image";

  const handleDownload = async () => {
    if (!qrCodeImage) {
      message.warning("File not found");
      return;
    }
    const downloadMessage = message.loading("Downloading", 0);
    try {
      const response = await axios({
        url: `${BACKEND_URL}api/upload/qrCode?fileName=${encodeURIComponent(
          qrCodeImage
        )}`,
        method: "GET",
        responseType: "blob",
      });
      // Extract the file name from the url
      const extractedFileName = qrCodeImage.split("/").pop();

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", extractedFileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      message.success("Downloaded!");
    } catch (error) {
      message.error("Error downloading the file");
      console.error("Error downloading the file:", error);
    } finally {
      downloadMessage();
    }
  };

  const buildBotUrl = () => {
    const url = new URL(`${FRONTEND_URL}/bot`);
    if (botRef) url.searchParams.set("ref", botRef);

    return url.toString();
  };

  const handleOpenChatbot = () => {
    const href = buildBotUrl();
    if (!botRef) {
      message.warning("Bot reference not found");
      return;
    }
    window.open(href, "_blank", "noopener,noreferrer");
  };

  const handleCopyLink = async () => {
    const href = buildBotUrl();
    try {
      await navigator.clipboard.writeText(href);
      message.success("Link copied to clipboard!");
    } catch (err) {
      console.error("Copy failed:", err);
      message.error("Failed to copy link.");
    }
  };

  return (
    <Card className="text-center border-0 shadow rounded-4 my-3">
      <Card.Body>
        <img
          src={qrCodeImage ? qrCodeImage : placeHolderImage}
          alt="QR Code"
          className="img-fluid mb-3"
          style={{ maxHeight: "140px", objectFit: "contain" }}
        />
        <Card.Title className="fw-bold text-primary mb-3">{title}</Card.Title>
        <Row className="justify-content-center">
          <Col xs="auto" className="p-1">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Download QR code</Tooltip>}
            >
              <Button
                variant="outline-success"
                className="rounded-3"
                onClick={() => handleDownload()}
              >
                <FontAwesomeIcon icon={faDownload} className="me-2" />
                Download
              </Button>
            </OverlayTrigger>
          </Col>

          <Col xs="auto" className="p-1">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Open Chatbot</Tooltip>}
            >
              <Button
                variant="outline-primary"
                className="rounded-3"
                onClick={() => handleOpenChatbot()}
              >
                <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="" />
              </Button>
            </OverlayTrigger>
          </Col>

          <Col xs="auto" className="p-1">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Copy URL</Tooltip>}
            >
              <Button
                variant="outline-secondary"
                className="rounded-3"
                onClick={() => handleCopyLink()}
              >
                <FontAwesomeIcon icon={faCopy} />
              </Button>
            </OverlayTrigger>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default QrCodeCard;
